import { render, staticRenderFns } from "./SysCheckRuleList.vue?vue&type=template&id=2b347d6b&scoped=true"
import script from "./SysCheckRuleList.vue?vue&type=script&lang=js"
export * from "./SysCheckRuleList.vue?vue&type=script&lang=js"
import style0 from "./SysCheckRuleList.vue?vue&type=style&index=0&id=2b347d6b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b347d6b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b347d6b')) {
      api.createRecord('2b347d6b', component.options)
    } else {
      api.reload('2b347d6b', component.options)
    }
    module.hot.accept("./SysCheckRuleList.vue?vue&type=template&id=2b347d6b&scoped=true", function () {
      api.rerender('2b347d6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/SysCheckRuleList.vue"
export default component.exports